var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"text-center pt-4"},[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":_vm.variant}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }